module.exports = __webpack_public_path__ + "static/upm.11975399.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/curriculum/upm.gif
// module id = 914
// module chunks = 25892245095017 57490047887898